import axios from "@/utils/axios";
export const sendThirdPartyPaymentEmail = async (store, data) => {
    store.commit("SET_SEND_THIRD_PARTY_PAYMENT_LOADING", true);
    store.commit("SET_SEND_THIRD_PARTY_PAYMENT_SUCCESS", null);
    const request = axios
        .post("/live-pay/send-third-party-payment-email", data)
        .then((response) => {
        store.commit("SET_SEND_THIRD_PARTY_PAYMENT_LOADING", false);
        store.commit("SET_SEND_THIRD_PARTY_PAYMENT_SUCCESS", true);
    })
        .catch((error) => {
        store.commit("SET_ERROR", error);
        store.commit("SET_SEND_THIRD_PARTY_PAYMENT_LOADING", false);
        store.commit("SET_SEND_THIRD_PARTY_PAYMENT_SUCCESS", false);
        store.dispatch("global-message/setMessage", {
            text: error,
            type: "error",
        }, { root: true });
    });
    return request;
};
export const setError = async (store, error) => {
    store.commit("SET_ERROR", error);
};
export const setSendThirdPartyPaymentEmailSuccess = async (store, success) => {
    store.commit("SET_SEND_THIRD_PARTY_PAYMENT_SUCCESS", success);
};
export const setSendThirdPartyPaymentEmailLoading = async (store, loading) => {
    store.commit("SET_SEND_THIRD_PARTY_PAYMENT_LOADING", loading);
};
export const setSelectedEducation = async (store, selectedEducation) => {
    store.commit("SET_SELECTED_EDUCATION", selectedEducation);
};
export const reset = async (store) => {
    store.commit("SET_SELECTED_EDUCATION", null);
    store.commit("SET_ERROR", null);
    store.commit("SET_SEND_THIRD_PARTY_PAYMENT_LOADING", false);
    store.commit("SET_SEND_THIRD_PARTY_PAYMENT_SUCCESS", null);
};
export default {
    setError,
    setSendThirdPartyPaymentEmailSuccess,
    setSendThirdPartyPaymentEmailLoading,
    setSelectedEducation,
    sendThirdPartyPaymentEmail,
    reset,
};
